import {
  arrayOf,
  bool, number,
  shape,
  string
} from '@thd-nucleus/data-sources/react/dataModel/prop-types';
import { params, alias } from '@thd-nucleus/data-sources';

let AisleBayModel = params({
  itemId: string().isRequired(),
  storeId: string().isRequired(),
  aisleBayText: string().isRequired(),
  phoneNumber: string().isRequired(),
  isSavingsSubscribed: bool()
});

// ds21 does not have .mutation
// @todo remove check when on 22
if (AisleBayModel.mutation) {
  AisleBayModel = AisleBayModel.mutation().shape({
    result: string()
  });
} else {
  AisleBayModel = AisleBayModel.shape({
    result: string()
  });
}

export const dataModel = {
  clientOnlyProduct: alias('product').params({ itemId: string().isRequired() }).shape({
    identifiers: shape({
      productType: string(),
      storeSkuNumber: string()
    }),
    fulfillment: params({ storeId: string() }).shape({
      fulfillmentOptions: arrayOf(shape({
        type: string(),
        services: arrayOf(shape({
          type: string(),
          locations: arrayOf(shape({
            isAnchor: bool(),
            type: string(),
            storeName: string(),
            inventory: shape({
              isInStock: bool(),
              quantity: number()
            })
          }))
        }))
      }))
    }),
    availabilityType: shape({
      type: string()
    })
  }),
  aislebay: params({ storeId: string().isRequired(), storeSkuIds: arrayOf(string().isRequired()) }).shape({
    storeSkus: arrayOf(shape({
      aisleBayInfo: shape({
        aisle: string(),
        bay: string(),
        invLocDesc: string()
      })
    }))
  }),
  aisleBayTextMe: AisleBayModel
};
